import { render } from "./NewBotConfiguration.vue?vue&type=template&id=8a18c1e0&scoped=true"
import script from "./NewBotConfiguration.vue?vue&type=script&lang=js"
export * from "./NewBotConfiguration.vue?vue&type=script&lang=js"

import "./NewBotConfiguration.vue?vue&type=style&index=0&id=8a18c1e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a18c1e0"]])

export default __exports__